"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.getDurationInHoursAndMinutes = getDurationInHoursAndMinutes;
exports.getLightFlights = getLightFlights;
exports.getPopularFlights = getPopularFlights;
exports.getResultsWithoutTopPicks = getResultsWithoutTopPicks;
exports.getSortItem = getSortItem;
exports.getSortItinerariesHashMap = getSortItinerariesHashMap;
exports.getSortItineraryHashMap = getSortItineraryHashMap;
exports.getSortPrice = getSortPrice;
exports.getSortPriceAndDuration = getSortPriceAndDuration;
exports.getSortPriceDurationHashMap = getSortPriceDurationHashMap;
exports.getSortPriceHashMap = getSortPriceHashMap;
exports.getTopPicks = getTopPicks;
exports.getTopPicksHashMap = getTopPicksHashMap;
exports.getUpgradableFlights = getUpgradableFlights;
exports.isValidSortKey = isValidSortKey;
var _reverse2 = _interopRequireDefault(require("lodash/reverse"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _split4 = _interopRequireDefault(require("lodash/split"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _minBy2 = _interopRequireDefault(require("lodash/minBy"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _padStart2 = _interopRequireDefault(require("lodash/padStart"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _constants = require("../constants");
function sort(results, sortKey) {
  if (!isValidSortKey(sortKey)) {
    return results;
  }
  var _split2 = (0, _split4.default)(sortKey, _constants.SORT_KEY_SEPARATOR),
    by = _split2[0],
    order = _split2[1];
  var sortByPath = _constants.SORT_BY_MAP[by];
  if (order === _constants.SORT_ORDER_MAP.DESC) {
    return (0, _reverse2.default)((0, _sortBy2.default)(results, sortByPath));
  }
  return (0, _sortBy2.default)(results, sortByPath);
}
function isValidSortKey(sortKey) {
  var _split3 = (0, _split4.default)(sortKey, _constants.SORT_KEY_SEPARATOR),
    by = _split3[0],
    order = _split3[1];
  return Object.values(_constants.SORT_ORDER_MAP).includes(order) && Object.keys(_constants.SORT_BY_MAP).includes(by);
}
function getSortPrice(itineraries, sortKey) {
  return (0, _get2.default)((0, _minBy2.default)(itineraries, sortKey), 'displayPrice.total', '0');
}
function getDurationInHoursAndMinutes(durationInSeconds) {
  var durationInHours = (0, _padStart2.default)(Math.floor(durationInSeconds / 3600).toString(), 2, '0');
  var durationInMinutes = (0, _padStart2.default)(Math.floor(durationInSeconds % 3600 / 60).toString(), 2, '0');
  return durationInHours + "h " + durationInMinutes + "m";
}
function getSortPriceAndDuration(itineraries, sortKey) {
  var price = (0, _get2.default)((0, _minBy2.default)(itineraries, sortKey), 'displayPrice.total', 0);
  var durationInSeconds = (0, _get2.default)((0, _minBy2.default)(itineraries, sortKey), 'itineraryDuration', 0);
  var duration = getDurationInHoursAndMinutes(durationInSeconds);
  return {
    price: price,
    duration: duration
  };
}
function getSortPriceHashMap(itineraries) {
  var _ref;
  return _ref = {}, _ref[_constants.SORT_BY_MAP.cheapestScore + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPrice(itineraries, _constants.SORT_BY_MAP.cheapestScore), _ref[_constants.SORT_BY_MAP.shortestScore + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPrice(itineraries, _constants.SORT_BY_MAP.shortestScore), _ref[_constants.SORT_BY_MAP.bestScore + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPrice(itineraries, _constants.SORT_BY_MAP.bestScore), _ref;
}
function getSortPriceDurationHashMap(itineraries) {
  var _ref2;
  return _ref2 = {}, _ref2[_constants.SORT_BY_MAP.cheapestScore + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPriceAndDuration(itineraries, _constants.SORT_BY_MAP.cheapestScore), _ref2[_constants.SORT_BY_MAP.shortestScore + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPriceAndDuration(itineraries, _constants.SORT_BY_MAP.shortestScore), _ref2[_constants.SORT_BY_MAP.bestScore + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPriceAndDuration(itineraries, _constants.SORT_BY_MAP.bestScore), _ref2[_constants.SORT_BY_MAP.earliestDeparture + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPriceAndDuration(itineraries, _constants.SORT_BY_MAP.earliestDeparture), _ref2[_constants.SORT_BY_MAP.latestDeparture + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.DESC] = getSortPriceAndDuration(itineraries, _constants.SORT_BY_MAP.latestDeparture), _ref2[_constants.SORT_BY_MAP.earliestArrival + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPriceAndDuration(itineraries, _constants.SORT_BY_MAP.earliestArrival), _ref2[_constants.SORT_BY_MAP.latestArrival + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.DESC] = getSortPriceAndDuration(itineraries, _constants.SORT_BY_MAP.latestArrival), _ref2;
}
function getSortItineraryHashMap(itineraries) {
  var _ref3;
  return _ref3 = {}, _ref3[_constants.SORT_BY_MAP.cheapestScore + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPrice(itineraries, _constants.SORT_BY_MAP.cheapestScore), _ref3[_constants.SORT_BY_MAP.shortestScore + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPrice(itineraries, _constants.SORT_BY_MAP.shortestScore), _ref3[_constants.SORT_BY_MAP.bestScore + _constants.SORT_KEY_SEPARATOR + _constants.SORT_ORDER_MAP.ASC] = getSortPrice(itineraries, _constants.SORT_BY_MAP.bestScore), _ref3;
}
function getSortItem(itineraries, sortKey) {
  var minItinerary = (0, _minBy2.default)(itineraries, sortKey);
  return {
    id: (0, _get2.default)(minItinerary, 'id', 0),
    price: String((0, _get2.default)(minItinerary, 'displayPrice.total', 0)),
    itinerary: minItinerary
  };
}
function getSortItinerariesHashMap(itineraries) {
  return {
    cheapest: getSortItem(itineraries, _constants.SORT_BY_MAP.cheapestScore),
    shortest: getSortItem(itineraries, _constants.SORT_BY_MAP.shortestScore),
    recommended: getSortItem(itineraries, _constants.SORT_BY_MAP.bestScore),
    cheapestDirect: getSortItem((0, _filter2.default)(itineraries, function (itinerary) {
      return itinerary.stopsCount === 0;
    }), _constants.SORT_BY_MAP.cheapestScore)
  };
}
function getTopPicks(sortItinerariesHashMap) {
  var items = (0, _map2.default)(sortItinerariesHashMap, function (item) {
    return {
      id: item.id,
      itinerary: item.itinerary
    };
  });
  return items.reduce(function (topPicks, item) {
    var duplicatedItem = (0, _find2.default)(topPicks, {
      id: item.id
    });
    if (!duplicatedItem && (0, _isPlainObject2.default)(item.itinerary)) {
      topPicks.push(item);
    }
    return topPicks;
  }, []);
}
function getTopPicksHashMap(itineraries, groupedItineraries) {
  return {
    popular: getPopularFlights(itineraries),
    upgradable: getUpgradableFlights(groupedItineraries),
    light: getLightFlights(itineraries) ? [getLightFlights(itineraries)] : [],
    cheapest: [(0, _get2.default)(getSortItem(itineraries, _constants.SORT_BY_MAP.cheapestScore), 'itinerary')],
    shortest: [(0, _get2.default)(getSortItem(itineraries, _constants.SORT_BY_MAP.shortestScore), 'itinerary')],
    recommended: [(0, _get2.default)(getSortItem(itineraries, _constants.SORT_BY_MAP.bestScore), 'itinerary')]
  };
}
function makeRoute(itinerary) {
  var _itinerary$searchRequ, _itinerary$searchRequ2, _itinerary$searchRequ3, _itinerary$searchRequ4;
  var from = (_itinerary$searchRequ = itinerary === null || itinerary === void 0 ? void 0 : (_itinerary$searchRequ2 = itinerary.searchRequest) === null || _itinerary$searchRequ2 === void 0 ? void 0 : _itinerary$searchRequ2.firstOrigin) !== null && _itinerary$searchRequ !== void 0 ? _itinerary$searchRequ : '';
  var to = (_itinerary$searchRequ3 = itinerary === null || itinerary === void 0 ? void 0 : (_itinerary$searchRequ4 = itinerary.searchRequest) === null || _itinerary$searchRequ4 === void 0 ? void 0 : _itinerary$searchRequ4.lastDestination) !== null && _itinerary$searchRequ3 !== void 0 ? _itinerary$searchRequ3 : '';
  return (from + "-" + to).toUpperCase();
}
function getPopularFlights(itineraries) {
  var dayOfWeek = itineraries.length > 0 ? (0, _format.default)(itineraries[0].firstLegDepartureTime, 'dddd') : '';
  var route = itineraries.length > 0 ? makeRoute(itineraries[0]) : '';
  var popularFlights = (0, _get2.default)(_constants.TOP_PICKS_POPULAR_FLIGTHS, route + "." + dayOfWeek, []);
  return (0, _filter2.default)(itineraries, function (itinerary) {
    return (0, _intersection2.default)(itinerary.flightCodes, popularFlights).length === itinerary.flightCodes.length;
  });
}
function getUpgradableFlights(groupedItineraries) {
  return (0, _filter2.default)((0, _map2.default)(groupedItineraries, function (group) {
    return group[0];
  }), function (itinerary) {
    var _itinerary$fareFamili;
    return itinerary.fareFamilies && ((_itinerary$fareFamili = itinerary.fareFamilies) === null || _itinerary$fareFamili === void 0 ? void 0 : _itinerary$fareFamili.length) > 0 || _constants.FLEX_AIRLINES.includes(itinerary.validatingCarrier);
  });
}
function getLightFlights(itineraries) {
  var allLightFlights = (0, _filter2.default)(itineraries, function (itinerary) {
    var _itinerary$firstLeg, _itinerary$firstLeg2;
    return ((_itinerary$firstLeg = itinerary.firstLeg) === null || _itinerary$firstLeg === void 0 ? void 0 : _itinerary$firstLeg.departureHour) < 12 && ((_itinerary$firstLeg2 = itinerary.firstLeg) === null || _itinerary$firstLeg2 === void 0 ? void 0 : _itinerary$firstLeg2.departureHour) > 6 && itinerary.stopsCount === 0 && !itinerary.hasCheckInBaggage;
  });
  return (0, _minBy2.default)(allLightFlights, _constants.SORT_BY_MAP.cheapestScore);
}
function getResultsWithoutTopPicks(_ref4) {
  var topPicks = _ref4.topPicks,
    searchResults = _ref4.searchResults,
    isDomestic = _ref4.isDomestic;
  var topPicksItineraryIds = (0, _map2.default)(topPicks, 'id');
  return (0, _filter2.default)(searchResults, function (searchResult) {
    return !topPicksItineraryIds.includes(isDomestic ? (0, _get2.default)(searchResult, 'id') : (0, _get2.default)(searchResult, '0.id'));
  });
}
var _default = exports.default = sort;